import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import FormContent from './FormContent';
Banner01.propTypes = {

};

function Banner01(props) {
    return (
        <section className="tf-slider sl5  parallax">
            <div className="content"></div>
            <div className="container ">
                <div className="row ">
                    <div className="col-lg-12">
                        <FormContent />
                    </div>
                </div>
            </div>
            {/* 2 */}
            <div className="overlay"></div>
        </section>
    );
}

export default Banner01;